"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HubSpotIssueType = exports.CancelPaymentRequestStatus = exports.CancelPaymentRequestReason = exports.AccountPaymentStatus = exports.AccountFollowerStatus = exports.AccountStatus = exports.AccountRole = void 0;
var AccountRole;
(function (AccountRole) {
    AccountRole["Member"] = "member";
    AccountRole["Leader"] = "group_leader";
    AccountRole["Admin"] = "admin";
    AccountRole["CommunityLeader"] = "community_leader";
    AccountRole["PeerGf"] = "peer_group_leader";
})(AccountRole = exports.AccountRole || (exports.AccountRole = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["Active"] = "active";
    AccountStatus["Inactive"] = "inactive";
    AccountStatus["Pending"] = "pending";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AccountFollowerStatus;
(function (AccountFollowerStatus) {
    AccountFollowerStatus["Active"] = "active";
    AccountFollowerStatus["Inactive"] = "inactive";
})(AccountFollowerStatus = exports.AccountFollowerStatus || (exports.AccountFollowerStatus = {}));
var AccountPaymentStatus;
(function (AccountPaymentStatus) {
    AccountPaymentStatus["Free"] = "free";
    AccountPaymentStatus["Paying"] = "paying";
    AccountPaymentStatus["Cancelled"] = "cancelled";
    AccountPaymentStatus["Undefined"] = "none";
})(AccountPaymentStatus = exports.AccountPaymentStatus || (exports.AccountPaymentStatus = {}));
var CancelPaymentRequestReason;
(function (CancelPaymentRequestReason) {
    CancelPaymentRequestReason["Default"] = "";
    CancelPaymentRequestReason["ConnectedToFacilitator"] = "Don\u2019t feel connected to my facilitator";
    CancelPaymentRequestReason["ConnectedToCircle"] = "Don\u2019t feel connected to my Circle";
    CancelPaymentRequestReason["MeetingTimeNotGood"] = "Day or hour are not a good fit";
    CancelPaymentRequestReason["PreferTherapy"] = "Prefer 1:1 therapy";
    CancelPaymentRequestReason["TechnicalIssues"] = "Technical issues";
    CancelPaymentRequestReason["PreferLocalSupportGroup"] = "Prefer local support group";
    CancelPaymentRequestReason["FinancialReasons"] = "It\u2019s too expensive";
    CancelPaymentRequestReason["ReadyToMoveOn"] = "I\u2019m ready to move on";
    CancelPaymentRequestReason["NotReadyToStart"] = "I\u2019m not ready to start";
    CancelPaymentRequestReason["DoNotHaveTime"] = "I have a busy schedule";
    CancelPaymentRequestReason["Other"] = "Other";
})(CancelPaymentRequestReason = exports.CancelPaymentRequestReason || (exports.CancelPaymentRequestReason = {}));
var CancelPaymentRequestStatus;
(function (CancelPaymentRequestStatus) {
    CancelPaymentRequestStatus["New"] = "new";
    CancelPaymentRequestStatus["ReEnabled"] = "re-enabled";
    CancelPaymentRequestStatus["Approved"] = "approved";
})(CancelPaymentRequestStatus = exports.CancelPaymentRequestStatus || (exports.CancelPaymentRequestStatus = {}));
var HubSpotIssueType;
(function (HubSpotIssueType) {
    HubSpotIssueType["TechnicalIssue"] = "Technical Issue";
    HubSpotIssueType["CancellationRequest"] = "Cancelation request";
    HubSpotIssueType["GroupPlacement"] = "Group placement";
    HubSpotIssueType["DeleteAccount"] = "Delete account";
    HubSpotIssueType["DuplicateSubscription"] = "Duplicate subscription";
    HubSpotIssueType["ContactUs"] = "Contact Us";
})(HubSpotIssueType = exports.HubSpotIssueType || (exports.HubSpotIssueType = {}));
//# sourceMappingURL=account.js.map